module.exports = __webpack_public_path__ + "static/jeroen-den-otter-661248-unsplash-f4ab754ddc647ebc0ed96224e24480d0.jpg";